import { configureStore } from '@reduxjs/toolkit'
import headerSlice from '../features/common/headerSlice'
import modalSlice from '../features/common/modalSlice'
import rightDrawerSlice from '../features/common/rightDrawerSlice'
import leftSidebarSlice from '../features/common/leftSidebarSlice'
//import leadsSlice from '../features/leads/leadSlice'

const combinedReducer = {
  header : headerSlice,
  rightDrawer : rightDrawerSlice,
  leftSidebar : leftSidebarSlice,
  modal : modalSlice
 // lead : leadsSlice
}

export default configureStore({
    reducer: combinedReducer
})